<template>
	<div
		class="app-catalog"
	>
		<template v-if="!(current_company_url === 'demo-courses' || current_company_url === 'soft-skills' || current_company_url === 'scorm')">
			<PresetSelection
				v-if="presets.length > 0"
				:presets="presets"
				:current_company_name="current_company_name"
				:current_company_url="current_company_url"
			/>
		</template>

		<div v-if="is_current_user" class="app-catalog__row">
			<MyActiveCourses
				:selection="active_courses"
			/>
			<MyWishesCourses
				:selection="wishes"
			/>
		</div>

		<AppCatalogCategories
			:categories="filtered_categories"
			:newest_courses="newest_courses"
			:current_company_url="current_company_url"
		/>
	</div>
</template>

<script>
import PresetSelection from "./Catalog/PresetSelection.vue";
import CoursesCatalogSelection from "./Catalog/Selection.vue";
import Topic from "./Topic.vue";
import MyActiveCourses from "./MyActiveCourses.vue";
import MyWishesCourses from "./MyWishesCourses.vue";
import AppCatalogCategories from "./AppCatalogCategories.vue";

export default {
	name: "CoursesCatalog",

	components: {
		PresetSelection,
		CoursesCatalogSelection,
		Topic,
		MyActiveCourses,
		MyWishesCourses,
		AppCatalogCategories
	},

	props: {
		presets: Array,
		categories: Array,
		newest_courses: Object,
		wishes: Array,
		active_courses: Array,
		current_company_url: {
			type: String,
			default: ''
		},
		current_company_name: {
			type: String,
			default: ''
		},
		is_current_user: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			loading: false,
		};
	},

	computed: {
		filtered_categories() {
			return this.categories.filter((i) => i.courses.length > 0)
		},
	},

	methods: {
	},
};
</script>
